module.exports = __webpack_public_path__ + "img/popup-emergency.c1059479.svg";